import type { Client } from 'graphql-models';
import type { Factory } from './helpers';

const MOCK_CLIENT: Client = {
  id: '1',
  clientNameLocal: 'Local Client',
  clientNameMaster: 'Master Client',
};

export const clientFactory: Factory<Client> = (overrides) => ({
  ...MOCK_CLIENT,
  ...overrides,
});
